


// jQuery使用できます

$(document).ready(function () {
    $('.index-section').has('.titleWrap').addClass('hasTitle');
});


// Instagramのタイトル

function replaceInstaFeedTitle() {
    const target = $('.template-index #insta-feed h2');
    if (target.length > 0) {
        target.replaceWith(`
            <div class="titleWrap instagram">
                <img width="365" class="ab serif" src="https://cdn.shopify.com/s/files/1/0653/6619/6442/files/insta_top2412.png?2" alt="スタッフいちおしレシピやお得な情報を発信中！">
                <h2>Instagram</h2>
            </div>
        `);
    }
}

// 初回の読み込み時に置き換え
setTimeout(replaceInstaFeedTitle, 2000);

